import axios from 'axios'
import store from '../store/index'
import msalInstance from '../auth/msalInstance'
import { loginRequest } from '../auth/msalConfig'

const jwtInterceptor = axios.create({ baseURL: '/api' })

jwtInterceptor.interceptors.request.use(async (config) => {
  let idToken = store.getters.idToken

  if (!idToken) {
    const accounts = msalInstance.getAllAccounts()
    if (accounts.length > 0) {
      try {
        const result = await msalInstance.acquireTokenSilent({
          ...loginRequest,
          account: accounts[0],
        })
        idToken = result.idToken
        store.commit('SET_ID_TOKEN', idToken)
      } catch (e) {
        store.commit('CLEAR_AUTH')
        return config
      }
    }
  }

  if (idToken) {
    config.headers['Authorization'] = `Bearer ${idToken}`
  }

  return config
})

jwtInterceptor.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      const accounts = msalInstance.getAllAccounts()
      if (accounts.length > 0) {
        try {
          const result = await msalInstance.acquireTokenSilent({
            ...loginRequest,
            account: accounts[0],
          })
          store.commit('SET_ID_TOKEN', result.idToken)
          error.config.headers['Authorization'] = `Bearer ${result.idToken}`
          return axios(error.config)
        } catch (e) {
          store.commit('CLEAR_AUTH')
        }
      } else {
        store.commit('CLEAR_AUTH')
      }
    }
    return Promise.reject(error)
  }
)

export default jwtInterceptor
